import { useState, useEffect } from "react";

export default function CeilingHeight({ defaultValue, errors }) {
  const [value, setValue] = useState(
    defaultValue !== undefined && defaultValue !== null
      ? parseFloat(defaultValue)
      : "",
  );

  const [isSmall] = useState(window.innerWidth <= 1500);

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      setValue(parseFloat(defaultValue));
    }
  }, [defaultValue]);

  const options = [2.6, 2.8, 3.0, 3.2, 3.5, 3.8, 4.0, 4.5, 5.0];

  return (
    <div
      className="ceilingHeight"
      style={{
        border: errors?.ceiling_height ? "2px solid red" : "none",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <h5>{isSmall ? "ԱՌ. ԲԱՐՁ․" : "ԱՌԱՍՏԱՂԻ ԲԱՐՁ․"}</h5>

      <div className="with">
        {options.map((v, i) => (
          <div key={i}>
            <input
              type="radio"
              name="ceiling_height"
              id={`c${i}`}
              value={v}
              checked={value === v}
              onChange={(e) => setValue(parseFloat(e.target.value))}
            />
            <label htmlFor={`c${i}`}>{v}մ</label>
          </div>
        ))}
      </div>
    </div>
  );
}
